import {
  DeleteOutlined,
  SearchOutlined,
  FileExcelOutlined,
  MailOutlined,
} from "@ant-design/icons";
import {
  Button,
  Descriptions,
  Divider,
  Form,
  Input,
  Modal,
  notification,
  Popconfirm,
  Space,
  Table,
  Tooltip,
} from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import { AdminService } from "src/resources/AdminService";
import { GlobalVariables } from "src/resources/GlobalVariables";

const AdminPage = () => {
  const [surveys, setSurveys] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [students, setStudents] = useState(null);
  const [state, setState] = useState({ searchText: "", searchedColumn: "" });
  const { lg } = useBreakpoint();
  const searchInput = useRef();
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      AdminService.getSurveys().then((data) => {
        setSurveys(data.data);
        console.log(data.data);
        const st = [];
        data.data
          .filter((d) => d.answer === true)
          .map((s) => {
            s.students.map((a) => {
              st.push({
                firstname: a.firstname,
                lastname: a.lastname,
                level: a.level,
              });
            });
          });
        setStudents(st);
      });
    }
  }, [initialRender]);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setState({ ...state, searchText: "" });
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
      }
    },
    render: (text) => text,
  });

  const columns = [
    {
      title: "Veli Adı",
      dataIndex: "firstname",
      ...getColumnSearchProps("firstname"),
      sorter: (a, b) => GlobalVariables.compare(a.firstname, b.firstname),
    },
    {
      title: "Veli Soyadı",
      dataIndex: "lastname",
      ...getColumnSearchProps("lastname"),
      sorter: (a, b) => GlobalVariables.compare(a.lastname, b.lastname),
    },
    {
      title: "Anket Tercihi",
      dataIndex: "answer",
      render: (answer) => (answer ? "Evet" : "Hayır"),
      sorter: (a, b) =>
        GlobalVariables.compare(a.answer.toString(), b.answer.toString()),
    },
    {
      title: "Öğrenci Sayısı",
      dataIndex: "students",
      render: (students) => students.length,
    },
    {
      title: "Anket Tarihi",
      dataIndex: "createdOn",
      render: (cretedOn) => moment(cretedOn).format("DD-MM-YY HH:mm"),
    },
    // {
    //   title: "Sil",
    //   render: (item) => (
    //     <Space>
    //       <Tooltip title="Delete Student" placement="left">
    //         <Popconfirm
    //           title="Are you sure ?"
    //           onConfirm={() => deleteStudent(item.id)}
    //           okText="Yes! Delete."
    //           cancelText="Cancel"
    //         >
    //           <Button type="primary" danger icon={<DeleteOutlined />} />
    //         </Popconfirm>
    //       </Tooltip>
    //     </Space>
    //   ),
    // },
  ];
  const scolumns = [
    {
      title: "Ad",
      dataIndex: "firstname",
    },
    {
      title: "Soyad",
      dataIndex: "lastname",
    },
    {
      title: "Year",
      dataIndex: "level",
    },
  ];
  const deleteStudent = (id) => {
    console.log(id);
    AdminService.deleteStudent(id).then((data) => {
      notification.success({
        message: "Success!",
        description: "Student Deleted!",
      });
      setInitialRender(true);
    });
  };

  const exportExcel = () => {
    AdminService.getExcel().then((data) => {
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "students.xlsx");
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <div className="mx-auto container min-h-screen">
      <br />
      <img
        className="relative mx-auto mb-4"
        width={250}
        src={require("../assets/images/logo.png").default}
        alt="logo"
      />
      <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl pb-24">
        <svg
          className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
          width={404}
          height={784}
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect
                x={0}
                y={0}
                width={4}
                height={4}
                className="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width={404}
            height={784}
            fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
          />
        </svg>

        <div className="relative">
          <h2 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-amazonl sm:text-4xl">
            KUR'AN KURSU ANKET SONUCLARI
          </h2>
        </div>
        <br />
        {!lg && (
          <div className=" flex items-center justify-center bg-gray-50 bg-opacity-80 rounded-lg py-6 px-4 sm:px-6 lg:px-8 shadow-lg border border-gray-400">
            <div className="max-w-md w-full space-y-8 text-center">
              <div>
                <p>
                  Your screen size is very small. <br />
                  Large screen required for this page.
                  <br />
                  Please connect desktop computer.
                  <br /> Thank you
                </p>
                <br />
              </div>
            </div>
          </div>
        )}
        {lg && (
          <>
            {/* {" "}
            <Button
              style={{ float: "right" }}
              type="primary"
              icon={<FileExcelOutlined />}
              onClick={exportExcel}
            >
              Export Excel
            </Button> */}
            <Table
              title={() =>
                surveys && (
                  <span className="text-amazonl font-semibold text-base">
                    ANKET SAYISI : {surveys.length}
                  </span>
                )
              }
              dataSource={surveys}
              bordered
              pagination={false}
              columns={columns}
              size="small"
              loading={surveys === null}
              rowKey="id"
            />
            <br /> <Divider orientation="left">Öğrenciler</Divider>
            {students && (
              <Table
                title={() =>
                  students && (
                    <span className="text-amazonl font-semibold text-base">
                      OGRENCI SAYISI : {students.length}
                    </span>
                  )
                }
                dataSource={students}
                size="small"
                bordered
                columns={scolumns}
                pagination={false}
                className="max-w-lg"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
